import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { IRewardState, LotteryRewardTypes, ShortLinkSubType, ShortLinkType } from 'src/types';
import { useStoreContext } from 'store/app';
import { useTranslationsContext } from 'store/translations';

import './rewardsModal.styl';

interface Props {
    reward: IRewardState;
    setSelectedReward: (reward: IRewardState) => void;
}

export const RewardCard = observer(({ reward, setSelectedReward }: Props) => {
    const { translate } = useTranslationsContext();
    const { openLink, logOperation } = useStoreContext();

    const { name, desc, img, background, logRender } = reward.renderParams;

    useEffect(() => {
        logRender && logOperation('rewards', 'render_reward', reward.id);
    }, []);

    return (
        <div
            className={classNames('rewards-modal-card', {
                isSpecial:
                    reward.lottery_reward_type === LotteryRewardTypes.RUBIES_SPECIAL ||
                    reward.lottery_reward_type === LotteryRewardTypes.LOGINS_SPECIAL
            })}
            style={{ background }}
            onClick={() => {
                if (reward.renderParams.modalTitle) {
                    setSelectedReward(reward);
                } else {
                    openLink(reward.renderParams.activateLink!, true, {
                        type: ShortLinkType.TAB,
                        subtype: ShortLinkSubType.REWARDS
                    });
                }
            }}
        >
            <div className="rewards-modal-card-content">
                <div className="rewards-modal-card-texts">
                    <div className="rewards-modal-card-title">{name}</div>
                    {reward.lottery_reward_type === LotteryRewardTypes.LOGINS_SPECIAL ? (
                        <div className="rewards-modal-card-reward">
                            <span className="rewards-modal-card-reward-label">{translate('quest.reward.label')}</span>
                            <span className="rewards-modal-card-reward-bubble">{translate('plus.promo')}</span>
                        </div>
                    ) : (
                        <div className="rewards-modal-card-description">{desc}</div>
                    )}
                </div>

                <img className="rewards-modal-card-image" src={img} />
            </div>
        </div>
    );
});
